import { isProd } from '../utils/utils';

type SentryConfig = {
  sendDefaultPii: boolean;
  maxValueLength: number;
  tracesSampleRate: number;
  tracePropagationTargets: (string | RegExp)[];
  replaysSessionSampleRate: number;
  replaysOnErrorSampleRate: number;
};

const nonProdConfig: SentryConfig = {
  sendDefaultPii: true,
  maxValueLength: 1_000_000,
  tracesSampleRate: 1.0,
  tracePropagationTargets: [
    /localhost:(3000|3001)/,
    /^https:\/\/app\.staging\.warden\.global/,
    /^https:\/\/pro\.staging\.warden\.global/,
  ],
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 1.0,
};

const prodConfig: SentryConfig = {
  sendDefaultPii: true,
  maxValueLength: 1_000_000,
  tracesSampleRate: 1.0,
  tracePropagationTargets: [/^https:\/\/app\.warden\.global/, /^https:\/\/pro\.warden\.global/],
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 1.0,
};

export function getSentryConfig(): SentryConfig {
  return isProd() ? prodConfig : nonProdConfig;
}
